import {Select} from "./Select.js";

export class HopeUserCountSelect extends Select {
    template() {
        const {addClassName = ""} = this.$props;
        return `
            <div class="interactive-form-wrap js-interactive-form-wrap">
                <i class="sign-icons-arrow-mini"></i>
                  <select id="hopeCountSelect" class="join-select-input interactive-form-input ${addClassName}" 
                      data-required-yn="Y" 
                      data-empty-msg="${i18next.t(login.expectMember)}">>
                        ${this.getOptionsTemplate()}
                  </select>
                  <span class="interactive-form-placeholder">${i18next.t(common.estimatedNumberOfPeople)}</span>
            </div>  
              <p class="error-txt-wrap">
                <span class="js-error-txt"></span>
              </p>
            `
    }

    getOptionsDataArr() {
        return[
            {value: "", text: `${i18next.t(login.expectMember)}`},
            {value: "10", text: `${i18next.t(login.countBelow, {count : 10})}`},
            {value: "11", text: `${i18next.t(login.countBetween, {above : 10, below : 30})}`},
            {value: "31", text: `${i18next.t(login.countBetween, {above : 31, below : 50})}`},
            {value: "51", text: `${i18next.t(login.countBetween, {above : 51, below : 99})}`},
            {value: "100", text: `${i18next.t(login.countOver, {count : 100})}`},
            {value: "500", text: `${i18next.t(login.countOver, {count : 500})}`},
            {value: "1000", text: `${i18next.t(login.countOver, {count : 1000})}`},
        ];
    }

    getQuerySelectorOfSelect() {
        return `#hopeCountSelect`
    }

    setEvent() {
        super.setEvent();

        if(Often.isGlobal()) return;

        this.addEvent("change", this.getQuerySelectorOfSelect(), e => {
            if(Number(Mutil.n2v($(this.getQuerySelectorOfSelect()).val(), "0")) >= 100) {
                $(".js-service-type-layer").css("display", "flex");
            } else {
                $(".js-service-type-layer").css("display", "none");
            }
        })
    }

}